import { useTheme } from '@emotion/react';
import { FormikProps } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';

import { Box, Button, Flex, Grid, Header, Icon } from '~/components/blocks';
import { CsClinicItemFragment } from '~/graphql/generated/graphql';

import { SearchCsClinics } from '../../SearchCsClinics';
import { Fields } from '../InputPane/types';

type Props = {
  editable: boolean;
  formik: FormikProps<Fields>;
  onBack: () => void;
  onSelectClinic: (csClinic: CsClinicItemFragment) => void;
  onConfirm: (values: Fields) => void;
  onAutoSave: (values: Fields) => void;
};

export const RecommendationPane = React.memo((props: Props) => {
  const { editable, formik, onSelectClinic, onConfirm, onAutoSave } = props;
  const theme = useTheme();

  const [isSelected, setIsSelected] = useState<boolean>(false);

  const handleSelect = useCallback(
    (csClinic: CsClinicItemFragment) => {
      formik.setFieldValue('csClinicId', csClinic.id);
      onSelectClinic(csClinic);
      setIsSelected(true);
    },
    [formik, onSelectClinic],
  );

  useEffect(() => {
    if (!isSelected) return;

    if (!editable) onAutoSave(formik.values);
    onConfirm(formik.values);
  }, [isSelected, editable, formik.values, onAutoSave, onConfirm]);

  return (
    <Grid height="100%" gridTemplateRows="min-content 1fr">
      <Flex>
        <Button size="xs" use="white" onClick={props.onBack}>
          <Icon icon="back-line" size="l" />
        </Button>
        <Header>{`メッセージ${props.editable ? '編集' : '作成'}`}</Header>
      </Flex>
      <Box marginTop={theme.space.s}>
        <SearchCsClinics onSelect={handleSelect} />
      </Box>
    </Grid>
  );
});

RecommendationPane.displayName = 'RecommendationPane';
